export const colors = {
  'dark-green-100': '#106c3a',
  'dark-green-150': '#0c592f',
  'dark-green-200': '#094826',
  'light-green': '#a7cd45',
  'light-green-2': '#f8ffe8',
  'light-green-50': '#ecf1ef',
  'light-green-100': '#dae3de',
  'light-green-200': '#b5c8be',
  grey: '#747486',
  'grey-light': '#696969',
  'grey-natural': '#cacfe2',
  'grey-50': '#f4f5f7',
  'grey-100': '#dde0e9',
  'grey-150': '#c6cad7',
  'grey-180': '#a2a9b9',
  'grey-200': '#6b778b',
  'grey-250': '#49505d',
  'white-100': '#fff',
  'black-100': '#303a3d',
  'black-light': '#606469',
  'green-6': '#f9ffe6', // Sand background color
  'green-10': '#f2fadb', // Success card background color
  'green-20': '#edf5d7',
  'green-25': '#d9e2bf',
  'green-30': '#e4f1c0', // Success card border (desktop)
  'green-35': '#e5f1c0', // Success card border (mobile)
  'green-40': '#dde8b9', // Time frame right side background color
  'green-45': '#d6e2b2', // Time frame (De 15 min a 48 h.) left side border color
  'green-50': '#d1dcaf', // Time frame right side border color
  'green-55': '#d2e69c',
  'green-100': '#a6ce39',
  'green-150': '#92b72e',
  'green-200': '#7e9f24',
  'green-350': '#106C3A',
  'red-20': '#fdf0ef',
  'red-input-border': '#f04942',
  'red-100': '#ce4340',
  'orange-100': '#ff6602',
  'yellow-20': '#fff7dc',
  'slider-light': '#8caf2c',
  'slider-dark': '#366c05',
  'yellow-1': '#fff5e7', // Warning box background color
  'yellow-2': '#ebe0c3', // Warning box border color
  'grey-1': '#e6e8f2', // Secondary card background color
  'grey-2': '#838897', // Desktop footer text
  'grey-3': '#c9cdd6', // Footer border for some reason
};

export const colorAliases = {
  primary: colors['dark-green-100'],
  warning: colors['orange-100'],

  'text-primary': colors['black-100'],
  'text-secondary': colors['grey-200'],
  'text-disabled': colors['grey-180'],

  'bg-primary': colors['white-100'],
  'bg-secondary': '#f6f6f9',
  'bg-overlay': '#27272788',
};

export const zIndexes = {
  'z-index-overlay': 10,
  'z-index-backdrop': 998,
  'z-index-modal-wrapper': 999,
  'z-index-modal': 1000,
  'z-index-notification': 1001,
};

export const misc = {
  'form-sm': '320px',
};

export const theme = {
  ...colors,
  ...colorAliases,
  ...zIndexes,
  ...misc,
};
